import { BookingSheet } from "./BookingSheet";

export const AgendaBookingSheet = ({ selection, session, onClose, onBooked, onAgenda }) =>
  <BookingSheet selection={selection} session={session} onClose={onClose} onBooked={onBooked}
    onAgenda={onAgenda || onClose} />;